import qs from 'query-string';
import { useLocation } from 'react-router-dom';

const useQueryParams = (...paramNames) => {
  const queryString = qs.parse(useLocation().search);
  return paramNames.map(paramName => queryString[paramName]);
};

export default useQueryParams;
